export type MovieGenreKey =
  | "ALL"
  | "ACTION_ADVENTURE"
  | "COMEDY"
  | "IMAGINARY"
  | "THRILLS"
  | "EMOTIONS"
  | "FAMILY"
  | "DOCUMENTARY"

export type MovieGenreGroup = {
  key: MovieGenreKey
  label: string
  genreIds: number[]
}

export const MOVIE_GENRE_GROUP_LIST: MovieGenreGroup[] = [
  {key: "ALL", label: "Tous", genreIds: []},
  {key: "ACTION_ADVENTURE", label: "Action & aventure", genreIds: [28, 12]},
  {key: "COMEDY", label: "Pour rire", genreIds: [35]},
  {key: "IMAGINARY", label: "Ailleurs et demain", genreIds: [878, 14]},
  {key: "THRILLS", label: "Tension & mystères", genreIds: [53, 80, 9648, 27]},
  {key: "EMOTIONS", label: "Histoires & émotions", genreIds: [18, 10749]},
  {key: "FAMILY", label: "Animation & famille", genreIds: [16, 10751]},
  {key: "DOCUMENTARY", label: "Documentaires", genreIds: [99]},
]

export const getMovieGenreIdList = (movie: any): number[] => {
  const rawGenreList = movie?.tmdbOptions?.genre_ids || movie?.tmdbOptions?.genres || []
  return rawGenreList
    .map((genre: number | {id?: number}) => typeof genre === "number" ? genre : genre?.id)
    .filter((genreId: number | undefined): genreId is number => Number.isFinite(genreId))
}

export const movieMatchesGenre = (movie: any, genreKey: MovieGenreKey) => {
  if (genreKey === "ALL") return true
  const group = MOVIE_GENRE_GROUP_LIST.find(item => item.key === genreKey)
  if (!group) return true
  const movieGenreIdList = getMovieGenreIdList(movie)
  return group.genreIds.some(genreId => movieGenreIdList.includes(genreId))
}

export const filterMoviesByGenre = (movieList: any[], genreKey: MovieGenreKey) => (
  movieList.filter(movie => movieMatchesGenre(movie, genreKey))
)

export const getAvailableMovieGenreGroups = (movieList: any[], minimumMovieCount = 1) => (
  MOVIE_GENRE_GROUP_LIST
    .map(group => ({
      ...group,
      movieCount: filterMoviesByGenre(movieList, group.key).length,
    }))
    .filter(group => group.key === "ALL" || group.movieCount >= minimumMovieCount)
)

export const getMovieYear = (movie: any) => {
  const releaseDate = movie?.tmdbOptions?.release_date || movie?.releaseDate
  return releaseDate ? String(releaseDate).slice(0, 4) : ""
}

export const getMovieRating = (movie: any) => {
  const rating = Number(movie?.tmdbOptions?.vote_average)
  return Number.isFinite(rating) && rating > 0 ? rating : null
}
